export default "L68\nL30\nR48\nL5\nR60\nL55\nL1\nL99\nR14\nL82"